import { gql } from '@apollo/client';

export const INSURANCE_CONVENTIONS_LIST_QUERY = gql`
  query insuranceConventionsList($pager: PagerInputNew, $filters: InsuranceConventionsFilterInput) {
    insuranceConventionsList(pager: $pager, filters: $filters) {
      total
      values {
        productId
        productCode
        productName
        isActive
      }
    }
  }
`;
